import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const EmbeddedSystems = () => {
  return <PageTemplate title="Embedded Systems" subtitle="Firmware & Hardware Solutions" breadcrumb="Engineering > Embedded Systems"><div className="content-section"><p>Embedded software, firmware development, and hardware integration services.</p></div></PageTemplate>;
};
export default EmbeddedSystems; 